import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-account-upgrade-tag',
  templateUrl: './account-upgrade-tag.component.html',
  styleUrls: ['./account-upgrade-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountUpgradeTagComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() hideTooltip: boolean;

  public show: boolean;
  public showDisabled: boolean;

  constructor() {}

  ngOnInit(): void {
    if (this.disabled) {
      this.show = false;
      this.showDisabled = true;
    } else {
      this.show = true;
      this.showDisabled = false;
    }
  }
}
